import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Star, Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen">
      <section className="relative bg-gradient-to-br from-pink-50 via-white to-pink-50 text-gray-600 py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6" data-aos="fade-right">
              <div className="flex items-center space-x-2">
                <h1 className="text-5xl md:text-6xl font-bold bg-primary-400 bg-clip-text text-transparent">
                  {t('home.title')}
                </h1>
              </div>
              <p className="text-xl md:text-2xl text-gray-600 leading-relaxed">
                {t('home.greeting')}
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                {t('home.description')}
              </p>
              <div className="flex flex-wrap gap-4 pt-4">
                <Link
                  to="/services"
                  className="bg-gradient-to-r from-primary-300 to-pink-400 hover:from-primary-400 hover:to-pink-500 text-gray-600 px-8 py-4 rounded-full font-semibold transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105"
                >
                  {t('home.viewServices')}
                </Link>
                <Link
                  to="/contact"
                  className="bg-white hover:bg-pink-50 text-pink-400 px-8 py-4 rounded-full font-semibold transition-all duration-200 shadow-lg hover:shadow-xl border-2 border-pink-300 hover:border-pink-400 hover:scale-105"
                >
                  {t('home.bookReading')}
                </Link>
              </div>
            </div>

            <div className="relative" data-aos="fade-left" data-aos-delay="200">
              <div className="aspect-square bg-gradient-to-br from-primary-300 to-pink-400 rounded-2xl shadow-2xl overflow-hidden">
                <img 
                  src="./hero_page.jpeg" 
                  alt="Arlene Tarot - Professional Tarot Reader" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-gradient-to-br from-pink-100 to-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-center text-pink-400 mb-12" data-aos="fade-up">
            {t('home.whyTarot')}
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="glass-card-primary p-8 rounded-xl shadow-lg" data-aos="fade-up" data-aos-delay="100">
              <div className="bg-primary-300 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                <Heart className="w-8 h-8 text-gray-600" />
              </div>
              <h3 className="text-2xl font-bold text-pink-400 mb-4">{t('home.connectPotential')}</h3>
              <p className="text-gray-600">
                {t('home.connectDesc')}
              </p>
            </div>

            <div className="glass-card-primary p-8 rounded-xl shadow-lg" data-aos="fade-up" data-aos-delay="200">
              <div className="bg-primary-300 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                <Sparkles className="w-8 h-8 text-gray-600" />
              </div>
              <h3 className="text-2xl font-bold text-pink-400 mb-4">{t('home.navigateComplexity')}</h3>
              <p className="text-gray-600">
                {t('home.navigateDesc')}
              </p>
            </div>

            <div className="glass-card-primary p-8 rounded-xl shadow-lg" data-aos="fade-up" data-aos-delay="300">
              <div className="bg-primary-300 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                <Star className="w-8 h-8 text-gray-600" />
              </div>
              <h3 className="text-2xl font-bold text-pink-400 mb-4">{t('home.findGuidance')}</h3>
              <p className="text-gray-600">
                {t('home.findGuidanceDesc')}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-gradient-to-br from-white to-pink-50">
        <div className="max-w-7xl mx-auto">
          <div className="rounded-2xl shadow-xl p-8 md:p-12" data-aos="zoom-in">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-pink-400 mb-8">
              {t('home.featuredContent')}
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="aspect-video rounded-xl overflow-hidden shadow-lg" data-aos="flip-left" data-aos-delay="100">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/videoseries?list=PLFGm7_E0u--CFQrIEZvXLit6Dgcv0pbHX"
                  title="Playlist 2026"
                  frameBorder="0"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
              <div className="aspect-video rounded-xl overflow-hidden shadow-lg" data-aos="flip-right" data-aos-delay="200">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/iQawr4JLFzE"
                  title="Escorpio 2026"
                  frameBorder="0"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
